import React, { useRef, useState } from 'react';

import MARKETBASE_THEME from '@dashboard/contexts/ThemeManager/theme';
import { ContentCopyOutlined, InventoryOutlined, OpenInNewOutlined } from '@mui/icons-material';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Tab,
  Tabs,
  Typography,
} from '@mui/material';

import CodeExampleContent from './CodeExampleContent';

type TCurrentTab = 'CURL' | 'NODE';

type Props = {
  open: boolean;
  handleClose: () => void;
};
export default function CodeExampleDialog({ open, handleClose }: Props) {
  const [currentTab, setCurrentTab] = useState<TCurrentTab>('CURL');
  const [isCopied, setIsCopied] = React.useState(false);
  const codeExampleRef = useRef<string>('');

  async function copyToClipboard() {
    await navigator.clipboard.writeText(codeExampleRef.current);
    setIsCopied(true);
    setTimeout(() => setIsCopied(false), 2000);
  }

  const handleCodeExampleGenerated = (code: string) => {
    codeExampleRef.current = code;
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Code examples</DialogTitle>
      <DialogContent>
        <Stack spacing={2}>
          <Typography color="text.secondary">
            Use these code examples to start sending emails using this template.
          </Typography>
          <Tabs
            value={currentTab}
            onChange={(_, value) => setCurrentTab(value)}
            sx={{ borderBottom: 1, borderColor: 'divider' }}
          >
            <Tab
              label="cURL"
              value="CURL"
              sx={{ ...MARKETBASE_THEME.typography.body1, fontWeight: 'fontWeightMedium' }}
            />
            <Tab label="Node.js" value="NODE" />
          </Tabs>

          <Stack spacing={1}>
            <Box sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 1 }}>
              <CodeExampleContent type={currentTab} onCodeGenerated={handleCodeExampleGenerated} />
            </Box>

            <Stack direction="row" justifyContent="space-between">
              <Button
                size="small"
                startIcon={
                  isCopied ? <InventoryOutlined sx={{ fontSize: 16 }} /> : <ContentCopyOutlined sx={{ fontSize: 16 }} />
                }
                onClick={copyToClipboard}
              >
                {isCopied ? 'Copied' : 'Copy code'}
              </Button>
              <Button
                size="small"
                href="https://www.usewaypoint.com/docs/api-reference/#send-an-email-with-a-template"
                target="_blank"
                endIcon={<OpenInNewOutlined sx={{ fontSize: 16, color: 'grey.500' }} />}
              >
                View docs
              </Button>
            </Stack>
          </Stack>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} variant="contained">
          Done
        </Button>
      </DialogActions>
    </Dialog>
  );
}
